var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepquality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_33239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D8EAF9",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1 35C24.7 35 23.3875 34.7333 22.1625 34.2C20.9375 33.6667 19.8708 32.9458 18.9625 32.0375C18.0542 31.1292 17.3333 30.0625 16.8 28.8375C16.2667 27.6125 16 26.3 16 24.9C16 22.4667 16.775 20.3208 18.325 18.4625C19.875 16.6042 21.85 15.45 24.25 15C23.95 16.65 24.0417 18.2625 24.525 19.8375C25.0083 21.4125 25.8417 22.7917 27.025 23.975C28.2083 25.1583 29.5875 25.9917 31.1625 26.475C32.7375 26.9583 34.35 27.05 36 26.75C35.5667 29.15 34.4167 31.125 32.55 32.675C30.6833 34.225 28.5333 35 26.1 35V35M26.1 33C27.5667 33 28.925 32.6333 30.175 31.9C31.425 31.1667 32.4083 30.1583 33.125 28.875C31.6917 28.7417 30.3333 28.3792 29.05 27.7875C27.7667 27.1958 26.6167 26.3917 25.6 25.375C24.5833 24.3583 23.775 23.2083 23.175 21.925C22.575 20.6417 22.2167 19.2833 22.1 17.85C20.8167 18.5667 19.8125 19.5542 19.0875 20.8125C18.3625 22.0708 18 23.4333 18 24.9C18 27.15 18.7875 29.0625 20.3625 30.6375C21.9375 32.2125 23.85 33 26.1 33V33M25.6 25.375V25.375V25.375V25.375V25.375V25.375V25.375V25.375V25.375V25.375V25.375V25.375",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_33239",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_33239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_33239",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepquality);
export default __webpack_public_path__ + "static/media/sleep quality.7624f1aa52183c0f6fd4a47d3d883381.svg";
export { ForwardRef as ReactComponent };